<style scoped>

</style>
<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
    @input="changeShow"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value=" display"
        :label="label"
        :disabled="disabled"
        :placeholder="placeholder"
        :required="required"
        :rules="rules"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="date"
      no-title
      range
      :locale="locale"
      :allowed-dates="allowedDates"
      scrollable
      @input="changeDate"
    >
      <v-spacer />
      <v-btn
        text
        color="primary"
        @click="close"
      >
        关闭
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>
<script>
  export default {
    props: {
      value: {
        type: Object
      },
      label: {
        type: String,
        default: '选择日期'
      },
      placeholder: {
        type: String,
        default: '点击选择'
      },
      locale: {
        type: String,
        default: 'zh'
      },
      required: {
        type: Boolean,
      },
      rules: {
        type: Array,
      },
      allowedDates: {
        type: Function,
        default: () => true
      },
      type: {
        type: String,
        default: () => undefined
      },
      start_key: {
        type: String,
      },
      end_key: {
        type: String,
      },
      disabled: {
        type: Boolean,
      }
    },
    data() {
      return {
        menu: false,
        date: []
      }
    },
    computed: {

      display() {
        const value = this.value 
        const start_key = this.start_key
        const end_key = this.end_key
        const start = value[start_key]
        const end = value[end_key]
        const arr = [start, end].filter(item => !!item)
        return arr
      }
    },
    methods: {
      close() {
        this.$refs.menu.save
      },
      changeDate(date_arr) {
        date_arr = [...date_arr].filter(item => !!item)
        date_arr.sort()
        this.$nextTick(() => {
          this.date = date_arr
        })
        this.$emit('input', date_arr);
      },
    }
  }
</script>
